function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "288",
  height: "288",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlnsSvgjs: "http://svgjs.com/svgjs"
}, props), /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  width: "288",
  height: "288"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "50.84",
  cy: "20.56",
  r: "6.64",
  fill: "#287ec4",
  className: (styles["colorfcb64d"] || "colorfcb64d") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43b651",
  d: "M61 41.31a21.16 21.16 0 01-20.33 0v-7.47a6.64 6.64 0 016.64-6.64h7.05A6.64 6.64 0 0161 33.84v7.47z",
  className: (styles["colorffcb29"] || "colorffcb29") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("circle", {
  cx: "13.16",
  cy: "20.56",
  r: "6.64",
  fill: "#287ec4",
  className: (styles["colorfcb64d"] || "colorfcb64d") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43b651",
  d: "M3 41.31a21.16 21.16 0 0020.33 0v-7.47a6.64 6.64 0 00-6.64-6.64H9.64A6.64 6.64 0 003 33.84v7.47z",
  className: (styles["colorffcb29"] || "colorffcb29") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("circle", {
  cx: "32",
  cy: "21.93",
  r: "8",
  fill: "#287ec4",
  className: (styles["colorfcb64d"] || "colorfcb64d") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  fill: "#017501",
  d: "M44.25 46.93a25.5 25.5 0 01-24.5 0v-9a8 8 0 018-8h8.5a8 8 0 018 8v9z",
  className: (styles["color44b3e6"] || "color44b3e6") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.81 26.35a7.62 7.62 0 00-4.97-13.42 7.65 7.65 0 00-4.97 13.43 7.6 7.6 0 00-5.2 3.74 8.93 8.93 0 00-3.16-1.08A8.98 8.98 0 0032 12.92a9.01 9.01 0 00-5.51 16.1c-1.13.16-2.2.53-3.15 1.07a7.56 7.56 0 00-5.2-3.74 7.62 7.62 0 00-4.98-13.42A7.65 7.65 0 008.2 26.35 7.65 7.65 0 002 33.85v7.46c0 .37.2.7.52.88a22.16 22.16 0 0016.23 2v2.74c0 .36.2.7.52.87 2.67 1.47 7 3.22 12.5 3.27H32c5.6 0 10-1.77 12.73-3.27a1 1 0 00.52-.87v-2.74a21.95 21.95 0 0016.23-2 1 1 0 00.52-.88v-7.47a7.65 7.65 0 00-6.19-7.5zM45.2 20.56a5.65 5.65 0 1111.29.02 5.65 5.65 0 01-11.3-.02zM25 21.93a7 7 0 1114.02.01A7 7 0 0125 21.93zM7.52 20.56a5.65 5.65 0 1111.3.02 5.65 5.65 0 01-11.3-.02zm5.82 22.36A19.98 19.98 0 014 40.71v-6.87c0-3.1 2.53-5.64 5.64-5.64h7.05a5.6 5.6 0 015.01 3.08 8.97 8.97 0 00-2.95 6.65v4.19c-1.76.5-3.58.79-5.4.8zm29.9 3.4a24.33 24.33 0 01-22.49 0v-8.4a7 7 0 017-7h8.5a7 7 0 017 7v8.4zM60 40.72a19.9 19.9 0 01-14.75 1.4v-4.18c0-2.64-1.14-5-2.95-6.65a5.62 5.62 0 015.01-3.08h7.05c3.11 0 5.64 2.53 5.64 5.64v6.87z",
  className: (styles["color000"] || "color000") + " " + (styles["svgShape"] || "svgShape")
}))));